"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _customPage = require("@/api/customPage");
//
//
//
//
//
//
//
//
//
//
//
var _default = exports.default = {
  props: ['itemDetail'],
  data: function data() {
    return {
      htmlText: ''
    };
  },
  mounted: function mounted() {
    var _this = this;
    console.log(this.$props.itemDetail);
    (0, _customPage.moduleDetail)({
      moduleId: this.$props.itemDetail.moduleId
    }).then(function (res) {
      if (res.data && res.data != null) {
        _this.htmlText = res.data.htmlText;
      }
    });
  },
  methods: {}
};